import {type FunctionalComponent, h} from '@stencil/core';
import type { SearchApiDocumentMySE } from '../../../../../../api/model/response/documents/private/MySEDocument';
import { UiaasSearchLabelList } from '../../../../result-cards/subcomponents/uiaas-search-label-list';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IDashboardTopicsItemProperties {
    doc: SearchApiDocumentMySE;
    labelProvider: labelProviderInterface;
}

export const DashboardTopicItemLabels: FunctionalComponent<IDashboardTopicsItemProperties> = (props) => {
    const { doc, labelProvider } = props;

    return (
      <span>
        <UiaasSearchLabelList
          list={[
            {
              value: doc?._id
            },
            {
              value: labelProvider('badge.topics', 'Topics'),
              customValueClass: 'document__category',
            },
          ]}
        />
        <br/>
        <UiaasSearchLabelList
          list={[
            {
              value: doc?.description,
              customValueClass: 'private-card-description'
            }
          ]}
        />
      </span>);
};
